<template>
  <div class="encumbrance">
    <div class="encumbrance-header">
      <!-- <button @click="qwe()">qwe</button> -->
      <h3>Обременение {{ encIndex + 1 }}</h3>
      <button class="btn" @click="closeButton">
        <img src="@img/close.svg" alt="">
        Скрыть
      </button>
    </div>
    <vue-custom-scrollbar class="scroll-encumbrance">
      <div class="encumbrance-block" >
        <div class="encumbrance-block-item" v-if="setEncumbranceData.name !== null && setEncumbranceData.name !== undefined">
          <h6>Тип обременения</h6>
          <p>{{ setEncumbranceData.name }}</p>
        </div>
        <div class="encumbrance-block-item" v-if="setEncumbranceData.encumbranceType !== null && setEncumbranceData.encumbranceType !== undefined">
          <h6>Описание</h6>
          <p>{{ setEncumbranceData.encumbranceType.text }}</p>
        </div>
        <div class="encumbrance-block-item" v-if="setEncumbranceData.regNumber !== null && setEncumbranceData.regNumber !== undefined">
          <h6>Номер</h6>
          <p>{{ setEncumbranceData.regNumber }}</p>
        </div>
        <div class="encumbrance-block-item" v-if="setEncumbranceData.regDate !== null && setEncumbranceData.regDate !== undefined">
          <h6>Дата</h6>
          <p>{{ setEncumbranceData.regDate }}</p>
        </div>
        <div class="encumbrance-block-item" v-if="setEncumbranceData.dateStarted !== null && setEncumbranceData.dateStarted !== undefined">
          <h6>Дата начала</h6>
          <p>{{ setEncumbranceData.dateStarted }}</p>
        </div>
        <div class="encumbrance-block-item" v-if="setEncumbranceData.dateStopped !== null && setEncumbranceData.dateStopped !== undefined">
          <h6>Дата окончания</h6>
          <p>{{ setEncumbranceData.dateStopped }}</p>
        </div>
        <div v-if="setEncumbranceData.documentSet !== undefined && setEncumbranceData.documentSet !== null && setEncumbranceData.documentSet.edges.length > 0">
          <div class="encumbrance-block-item" v-for="(doc, index) in setEncumbranceData.documentSet.edges" :key="index">
            <ToggleComponentVue :key="'toggle_' + index + '_encumbrance_doc'">
              <template #title>
                <h5>Документ {{ index + 1}}</h5>
              </template>
              <template #content>
                <div class="document-block">
                  <div class="document-block-item" v-if="doc.node.documentType !== null && doc.node.documentType !== undefined">
                    <h6>Тип документа</h6>
                    <p>{{ doc.node.documentType.text}}</p>
                  </div>
                  <div class="document-block-item" v-if="doc.node.seria">
                    <h6>Серия</h6>
                    <p>{{ doc.node.seria}}</p>
                  </div>
                  <div class="document-block-item" v-if="doc.node.number">
                    <h6>Номер</h6>
                    <p>{{ doc.node.number}}</p>
                  </div>
                  <div class="document-block-item" v-if="doc.node.date">
                    <h6>Дата</h6>
                    <p>{{ doc.node.date}}</p>
                  </div>
                  <div class="document-block-item" v-if="doc.node.notes">
                    <h6>Примечание</h6>
                    <p>{{ doc.node.notes}}</p>
                  </div>
                  <div class="document-block-item" v-if="doc.node.file">
                    <h6>Файл</h6>
                    <p>{{ doc.node.file}}</p>
                  </div>
                  <a v-if="doc.node.file !== null" :href="getDownloadDocUrl(doc.node.file)">
                    <div class="document-block-item">
                      Скачать
                    </div>
                  </a>
                </div>
              </template>
            </ToggleComponentVue>
          </div>
        </div>
        <div class="owner-wrap" v-if="setEncumbranceData.encumbranceOwnerSet !== null && setEncumbranceData.encumbranceOwnerSet !== undefined">
          <div class="encumbrance-block-item" v-for="(owner, index) in setEncumbranceData.encumbranceOwnerSet.edges" :key="index">
            <ToggleComponentVue>
              <template #title>
                <h5>Правообладатель {{ index + 1}}</h5>
              </template>
              <template #content>
                <div class="owner-block-item" v-if="owner.node.owner.sp !== null && owner.node.owner.sp !== undefined">
                  <h6>Вид правообладателя</h6>
                  <p>{{ owner.node.owner.sp.text}}</p>
                </div>
                <div class="type-owner" v-if="owner.node.owner.typeOfOwner !== null && owner.node.owner.typeOfOwner !== undefined">
                  <!-- <div class="organization" v-if="isOrganizationMix(owner.node.owner.sp.code) && owner.node.owner.organizationSet !== null">
                    <div class="organization-block" v-for="(org, index) in owner.node.owner.organizationSet.edges" :key="index"> -->
                  <div class="organization" v-if="isOrganizationMix(owner.node.owner.sp.code) && owner.node.owner.organization !== null">
                    <div class="organization-block">
                      <ToggleComponentVue>
                        <template #title>
                          <h5>Организация</h5>
                        </template>
                        <template #content>
                          <div class="owner-block-item" v-if="owner.node.owner.organization.name !== null && owner.node.owner.organization.name !== undefined">
                            <h6>Наименование</h6>
                            <p>{{ owner.node.owner.organization.name }}</p>
                          </div>
                          <div class="owner-block-item" v-if="owner.node.owner.organization.fullName !== null && owner.node.owner.organization.fullName !== undefined">
                            <h6>Полное наименование</h6>
                            <p>{{ owner.node.owner.organization.fullName }}</p>
                          </div>
                          <div class="owner-block-item" v-if="owner.node.owner.oid !== null && owner.node.owner.oid !== undefined">
                            <h6>ИНН/СНИЛС</h6>
                            <p>{{ owner.node.owner.oid }}</p>
                          </div>
                          <div class="owner-block-item" v-if="owner.node.owner.organization.ogrn !== null && owner.node.owner.organization.ogrn !== undefined">
                            <h6>ОГРН</h6>
                            <p>{{ owner.node.owner.organization.ogrn }}</p>
                          </div>
                          <!-- <div class="owner-block-item" v-if="owner.node.owner.organization.phone !== ''">
                            <h6>Номер телефона</h6>
                            <p>{{ owner.node.owner.organization.phone }}</p>
                          </div> -->
                        </template>
                      </ToggleComponentVue>
                    </div>
                  </div>
                  <div class="person" v-if="isPersonMix(owner.node.owner.sp.code)">
                    <div class="person-block">
                      <ToggleComponentVue>
                        <template #title>
                          <h5>Персона {{ index + 1}}</h5>
                        </template>
                        <template #content>
                          <div class="owner-block-item">
                          <div class="owner-block-item">
                            <h6>Фамилия</h6>
                            <p>{{ owner.node.owner.person.lastName }}</p>
                          </div>
                            <h6>Имя</h6>
                            <p>{{ owner.node.owner.person.firstName }}</p>
                          </div>
                          <div class="owner-block-item">
                            <h6>Отчество</h6>
                            <p>{{ owner.node.owner.person.middleName }}</p>
                          </div>
                          <!-- <div class="owner-block-item">
                            <h6>Номер телефона</h6>
                            <p>{{ owner.node.owner.person.phone }}</p>
                          </div> -->
                        </template>
                      </ToggleComponentVue>
                    </div>
                  </div>
                  <div class="governance" v-if="owner.node.owner.typeOfOwner.text === 'governance'">
                    <div class="governance-block">
                      <ToggleComponentVue>
                        <template #title>
                          <h5>Управление {{ index + 1}}</h5>
                        </template>
                        <template #content>
                          <div class="owner-block-item">
                            <h6>Наименование</h6>
                            <p>{{ owner.node.owner.governance.name }}</p>
                          </div>
                        </template>
                      </ToggleComponentVue>
                    </div>
                  </div>
                </div>
              </template>
            </ToggleComponentVue>
          </div>
        </div>
      </div>
    </vue-custom-scrollbar>
  </div>
</template>

<script>
import ToggleComponentVue from './ToggleComponentVue'
import { eventBus } from '@/main.js'

export default {
  props: ['encObj', 'pk'],
  data () {
    return {
      setEncumbranceData: {}
    }
  },
  components: {
    ToggleComponentVue
  },
  computed: {
    encIndex () {
      return this.$store.getters.value('encIndex')
    },
    rightIndex () {
      return this.$store.getters.value('rightIndex')
    }
  },
  created () {
    eventBus.$on('encFull', data => {
      this.setEncumbranceData = data
    })
  },
  methods: {
    qwe () {
      console.log(this.setEncumbranceData)
    },
    getDownloadDocUrl (key) {
      if (key === null) {
        return 'javascript:void(0)'
      }
      return this.getMinioFileUrlMix('document', key)
    },
    closeButton () {
      this.$store.dispatch('SET_VALUE', {key: 'encumbranceDetail', value: []})
    }
  }
}
</script>

<style lang="scss">
.encumbrance {
  position: absolute;
  padding: 30px 50px;
  top: 0;
  right: 0;
  height: 100%;
  width: 460px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  @media screen and (max-width: 768px){
    max-width: 100%;
    background-color: white;
    padding:30px 15px;
    z-index: 8;
  }
  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      vertical-align: bottom;
    }
  }
  &-block {
    padding-right: 15px;
    @media screen and (max-width: 768px){
      padding-right: 30px;
    }
    &-item {
      margin-bottom: 25px;
      padding-bottom: 25px;
      border-bottom: 1px solid #e6e6e6;
      h6 {
        font-size: 14px;
        margin-bottom: 10px;
      }
      p {
        margin-bottom: 0;
      }
    }
  }
  .scroll-encumbrance {
    position: absolute;
    overflow: auto;
    top: 90px;
    left: 50px;
    right: 35px;
    display: flex;
    flex-direction: column;
    // width: 100%;
    height: calc(100% - 133px);
    @media screen and (max-width: 768px){
      height: calc(100% - 90px);
      left: 15px;
      right: 0px;
    }
  }
}
.document {
  &-block {
    display: table;
    margin-top: 15px;
    &-item {
      display: table-row;
      &:last-child {
        h6,
        p {
          padding-bottom: 0;
        }
      }
      h6,
      p {
        display: table-cell;
        padding-bottom: 10px;
        font-size: 12px;
      }
      h6 {
        width: 105px;
        font-size: 12px;
        padding-right: 10px;
        text-align: right;
        font-weight: 400;
        color: #929292;
      }
    }
  }
}

.owner {
  &-block {
    &-item {
      margin-top: 20px;
      h6 {
        font-size: 12px;
        margin-bottom: 5px;
      }
      p {
        font-size: 12px;
      }
    }
  }
}

.organization-block,
.person-block,
.governance-block {
  padding-top: 25px;
  padding-bottom: 25px;
  border-bottom: 1px solid #e6e6e6;
  &:last-child {
    padding-bottom: 0;
    border: none
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EncumbranceVue.vue